<section class="activacion">
	<div class="activacion-header fondo-blue"></div>
	<section class="activacion-form">
		<div class="activacion-form-image">
			<img src="assets/images/logo-big.png" alt="Pawerful PetShop" loading="lazy"/>
		</div>
		<div class="activacion-form-content-controls">
			<button class="activacion-form-content-button fondo-purple-outline">
				<span class="color-purple-bold">
					Activando tu cuenta, se redirigirá a la página de inicio cuando.
				</span>
			</button>
		</div>
	</section>
</section>